/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">Add Plan</h4>
        <div>
            <!-- Default form login -->
            <form class="border border-light p-5">
                <div class="row">
                    <div class="form-group col-md-6">
                        <label>Title</label>
                        <input type="text" ref="title" id="" class="form-control mb-4" placeholder="Title">
                    </div>
                    <div class="form-group col-md-6">
                        <label>Price</label>
                        <input type="number" ref="price" id="" class="form-control mb-4" placeholder="Price">
                    </div>
                    <div class="form-group col-md-6">
                        <label>Duration</label>
                        <input type="number" id="" ref="duration" class="form-control mb-4" placeholder="Duration">
                    </div>
                    <div class="form-group col-md-6">
                        <label>Target</label>
                        <select class="form-control mb-4" ref="target">
                            <option value="STUDENT">STUDENT</option>
                            <option value="TEACHER">TEACHER</option>
                        </select>
                    </div>
                </div>

                <!-- Sign in button -->
                <button class="btn btn-info btn-block my-4" @click.prevent="addPlan()">Add Plan</button>

            </form>
            <!-- Default form login -->
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
export default {
    name: 'AddPlan',
    components: {

    },
    data() {
        return {
            fastAdminToken : localStorage.getItem("fastAdminToken")
        }
    },
    methods: {
        addPlan() {
            let data = {
                price: parseInt(this.$refs.price.value),
                title: this.$refs.title.value,
                duration: parseInt(this.$refs.duration.value),
                target: this.$refs.target.value
            }
            const config = {
                headers: {
                    Authorization: "Bearer " + this.fastAdminToken,
                    'Content-Type': 'application/json'
                }
            }
            this.$toast.open({
                message: "Processing : Creating Plan Please Wait...",
                type: 'info'
            })
            axios.post(this.$apiURI + "/plan/create", data, config)
                .then((response) => {
                    if (response.data.error) {
                        this.$toast.open({
                            message: "Error : " + response.data.message,
                            type: 'error'
                        });
                    } else {
                        this.$toast.open({
                            message: "Plan Created Successfully",
                            type: 'success'
                        })
                    }

                }).catch((error) => {
                    this.$toast.open({
                        message: "Error : " + error.response.data.message,
                        type: 'error'
                    });
                })
        }
    }
}
</script>
